import { useTranslation } from 'react-i18next';
import {
  EMPTY_ILLUSTRATIONS,
  EmptyContainer,
  Table,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import ProcessTemplatesTableRowActions from './process-templates-table-row-actions.component';

import { IProcessesTemplateTableProps } from './process-templates-table.interfaces';

const ProcessTemplatesTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  loading,
}: IProcessesTemplateTableProps) => {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <Table
      loading={loading}
      dataSource={dataSource}
      pagination={paginationConfig}
      rowKey={record => record._id}
      locale={{
        emptyText: (
          <EmptyContainer
            illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
            emptyTitle={t('settings:processTemplates.labels.noData')}
          />
        ),
      }}
      t={t}
    >
      <Table.Column
        title={t('settings:processTemplates.labels.title')}
        render={({ name }) => <Typography>{name}</Typography>}
      />
      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => (
          <ProcessTemplatesTableRowActions record={record} handleModals={handleModals} t={t} />
        )}
      />
    </Table>
  );
};

export default ProcessTemplatesTable;
